import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('ammotio-token');
axios.defaults.headers.common['Session'] = window.localStorage.getItem('ammotio-session');
